import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { AppBar, Avatar, Badge, Box, Hidden, IconButton, Toolbar, Typography, Collapse, Divider, Dialog, DialogContent, DialogContentText, DialogActions, Button, ClickAwayListener } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/NotificationsOutlined';
import Logo from './Logo';
import { ReactComponent as Thai } from "../assets/icons/thai.svg";
import { ReactComponent as En } from "../assets/icons/en.svg";
import { ReactComponent as LogoMain } from "../assets/images/logo.svg";
import { ReactComponent as Polygon } from "../assets/icons/polygon.svg";
import { ReactComponent as Logout } from "../assets/icons/logout.svg";
import { ReactComponent as History } from "../assets/icons/history.svg";
import { ReactComponent as Proxy } from "../assets/icons/proxy.svg";
import { ReactComponent as Profile } from "../assets/icons/profile.svg";
import { ReactComponent as Bell } from "../assets/icons/bell.svg";
import { ReactComponent as DialogCheck } from "../assets/images/dialog-check.svg";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { logout } from "../actions/auth";
import { makeStyles } from "@mui/styles";
import cssVariables from "../theme/cssVariables";
import SelectUser from "./SelectUser";
import SimpleDialog from "./SimpleDialog";
import { useTranslation } from "react-i18next";
import proxyService from "../services/proxy.service";
import * as Util from "../services/global.service";
// import { StackActions } from '@react-navigation/native';
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue } from "firebase/database";

const REACT_APP_DATA_BASE_URL = process.env.REACT_APP_DATA_BASE_URL;
const REACT_APP_MODE = process.env.REACT_APP_MODE;

const firebaseConfig = {
    databaseURL: REACT_APP_DATA_BASE_URL,
};

const DashboardNavbar = ({ onMobileNavOpen, ...rest }) => {
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch();
    const [fullName, setFullName] = useState("");
    const [imageProfile, setImageProfile] = useState("");
    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [fullVersion, setFullVersion] = useState(true);
    const [isCollapse, setIsCollapse] = useState(false);
    const [openSelectUser, setOpenSelectUser] = useState(false);
    const [open, setOpen] = useState(false);
    const [reset, setReset] = useState(false);
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [text, setText] = useState("");
    const [notifications] = useState([]);
    const Start = useSelector((state) => state.Start);
    const logo = localStorage.getItem("logo");
    const vLogo = Start?.data?.client?.logo ? Start?.data?.client?.logo : "";
    const navigate = useNavigate();
    const location = useLocation();
    const dataProfiles = JSON.parse(localStorage.getItem("user"));
    const proxy = JSON.parse(localStorage.getItem("proxy"));
    const photo = useSelector((state) => state?.auth?.user?.profile?.photo);
    const isSSO = (dataProfiles?.is_sso)
    const app = initializeApp(firebaseConfig);
    const [notificationsBell, setNotificationsBell] = useState({ read: true, total: 0 });
    const [showNotificationsBell, setShowNotificationsBell] = useState({ read: true, total: 0 });

    const db = getDatabase();
    const starCountRef = ref(db, `${REACT_APP_MODE}/${dataProfiles?.user}/`);
    onValue(starCountRef, (snapshot) => {
        const data = snapshot.val();
        if (Util.formatData(data?.notification, false) !== false && Boolean(notificationsBell?.read !== data?.notification?.read || notificationsBell?.total !== data?.notification?.total)) {
            setNotificationsBell(data?.notification)
        }
        if (Util.formatData(data?.security?.lock, false) === true) {
            logouts()
        }
    });


    const handleClose = () => {
        setOpen(false)
        let getPath = window?.location?.pathname
        if (getPath === "/kpi/home") {
            window.location.reload(false)
        } else {
            //console.log('URL', window.origin, new URL(".", window.origin + location.pathname))
            window.location.href = window.origin + '/kpi/home'
            //navigate('/kpi/home', { replace: false });
        }
        // window.location.reload(false);
    };
    const useStyles = makeStyles({
        clickable: {
            color: "#5DA196",
            textDecoration: "underline",
            cursor: "pointer",
            "&:hover, &:focus": {
                color: "#00846e",
            },
        },
    });
    useEffect(() => {
        displayFullName()
    }, [dataProfiles]);

    useEffect(() => {
        if (notificationsBell?.read !== showNotificationsBell?.read || notificationsBell?.total !== showNotificationsBell?.total) {
            if (notificationsBell?.total > showNotificationsBell?.total && document.getElementById('bell')) {
                document.getElementById('bell').animate([
                    { transform: 'rotate(0deg)' },
                    { transform: 'rotate(15deg)' },
                    { transform: 'rotate(-15deg)' },
                    { transform: 'rotate(10deg)' },
                    { transform: 'rotate(-10deg)' },
                    { transform: 'rotate(0deg)', offset: 0.5 }
                ], {
                    duration: 1500,
                });
            }
            setShowNotificationsBell(notificationsBell)
        }
    }, [notificationsBell]);

    useEffect(() => {
        let maybeHandler = (event) => {
            if (event.target.closest("#boxCollapse") === null) {
                setIsCollapse(false)
            }
        };

        document.addEventListener("click", maybeHandler);

        return () => {
            document.removeEventListener("click", maybeHandler);
        };
    }, []);

    document.addEventListener(
        'scroll',
        function (event) {
            if (isCollapse) {
                setIsCollapse(false);
            }
        },
        true
    );

    document.addEventListener(
        'keydown',
        function (event) {
            if (isCollapse) {
                setIsCollapse(false);
            }
        },
        true
    );

    useEffect(() => {
        setImageProfile(photo)
    }, [photo]);
    // useEffect(() => {
    //     setTimeout(() => {
    //         setReset(!reset)
    //     }, 1000);
    // }, [i18n.language]);
    const displayFullName = () => {
        if (dataProfiles !== undefined && dataProfiles !== "undefined" && dataProfiles !== null) {
            setFullName(dataProfiles?.profile?.firstname + ` ` + dataProfiles?.profile?.lastname)
            setImageProfile(dataProfiles?.profile?.photo)
        }
    }

    const displayCollapse = () => {
        setIsCollapse(!isCollapse)
    }

    let logouts = () => {
        dispatch(logout()).then(
            (response) => {
                let pathTologin = response?.data?.data?.url
                if (Util.formatData(pathTologin, false) !== false) {
                    const newWindow = window.open(pathTologin, '_self', 'noopener,noreferrer')
                    if (newWindow) newWindow.opener = null
                } else {
                    console.log('Navigate', 8);
                    //navigate('/' + localStorage.getItem("site"), { replace: false });
                    window.location.href = '/' + localStorage.getItem("site")
                }
                localStorage.removeItem("user");
                localStorage.removeItem("date");
                localStorage.removeItem("proxy");
            }
        ).catch((err) => {
            localStorage.removeItem('date');
            localStorage.removeItem('user');
            localStorage.removeItem("proxy");
            console.log('Navigate', 9);
            //navigate('/' + localStorage.getItem("site"), { replace: false });
            window.location.href = '/' + localStorage.getItem("site")
        })
        // navigate('/'+localStorage.getItem("site"), { replace: false });
    }

    let selectName = (data) => {
        if (data !== undefined && data?.profile !== undefined) {
            let dataProfile = data?.profile
            if (i18n.language === "th-TH" && dataProfile?.options?.name_th !== undefined && dataProfile?.options?.name_th !== null && dataProfile?.options?.name_th !== "") {
                return dataProfile?.options?.name_th;
            } else if (dataProfile?.options?.name_en !== undefined && dataProfile?.options?.name_en !== null && dataProfile?.options?.name_en !== "") {
                return dataProfile?.options?.name_en;
            } else {
                return dataProfile?.fullname;
            }
        }
        return "";
    }

    let selectNameUser = (data) => {
        if (data !== undefined && data?.profile !== undefined) {
            let dataProfile = data?.profile
            if (i18n.language === "th-TH" && dataProfile?.options?.name_th !== undefined && dataProfile?.options?.name_th !== null && dataProfile?.options?.name_th !== "") {
                return dataProfile?.options?.name_th;
            } else if (dataProfile?.options?.name_en !== undefined && dataProfile?.options?.name_en !== null && dataProfile?.options?.name_en !== "") {
                return dataProfile?.options?.name_en;
            } else {
                return dataProfile?.firstname + ` ` + dataProfile?.lastname
            }
        }
        return "";
    }

    const clickLink = (data) => {
        setIsCollapse(false)
        navigate(data, { replace: false });
    }

    const submit = (data, proxyBy) => {
        setOpenSelectUser(false)
        let selectData = {
            "proxy_target": data.serial,
            "proxy_by": proxyBy.serial
        }
        proxyService.loginByProxy(selectData).then((response) => {
            let dataProxy = {
                permission: response?.data?.permission !== undefined ? response?.data?.permission : [],
                profile: response?.data?.profile !== undefined ? response?.data?.profile : {},
                proxy_token: response?.data?.proxy_token !== undefined ? response?.data?.proxy_token : '',
                user: response?.data?.proxy_target !== undefined ? response?.data?.proxy_target : '',
            }
            localStorage.setItem("proxy", JSON.stringify(dataProxy));

            setText(`${t('proxy.actOnBehalf')} <br>"${data?.fullname}"`)
            openAlert()
        }).catch((err) => {
            console.log(err);
        })
    }

    const proxyOut = () => {
        let selectData = {
            "proxy_target": Util.formatData(proxy.user, ""),
            "proxy_by": Util.formatData(dataProfiles.user, "")
        }
        proxyService.logoutByProxy(selectData).then((response) => {
            openAlert()
            localStorage.removeItem("proxy");
            setText(t('proxy.becomeSelfSuccessfully'))
        }).catch((err) => {
            console.log(err);
        })
    }

    const openSelect = () => {
        setOpenSelectUser(true)
        setIsCollapse(false)
    }

    const closeSelect = () => {
        setOpenSelectUser(false)
    }

    let openAlert = () => {
        setOpen(true)
    }
    const styles = {
        title: {
            fontSize: "24px",
            lineHeight: "26.4px",
            color: cssVariables.color.primary
        },
        message: {
            fontSize: "16px",
            lineHeight: "26px",
            color: cssVariables.color.black
        },
        successTitle: {
            fontSize: "24px",
            lineHeight: "26.4px",
            color: cssVariables.color.black
        },
        successMessage: {
            fontSize: "18px",
            lineHeight: "24.59px",
            color: cssVariables.color.black
        },
        errorTitle: {
            fontSize: "24px",
            lineHeight: "26.4px",
            color: "#CC6058"
        },
        errorMessage: {
            fontSize: "18px",
            lineHeight: "24.59px",
            color: cssVariables.color.black
        },
    };
    return (
        <AppBar
            elevation={0}
            {...rest}
            color="black"
        >
            <Toolbar>
                <IconButton
                    size="large"
                    edge="start"
                    color="white"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                    onClick={onMobileNavOpen}
                >
                    <MenuIcon />
                </IconButton>
                {logo &&
                    <Box mr="30px">
                        <img style={{ maxHeight: '40px' }} src={logo} alt="IPOP PMS" />
                    </Box>
                }
                <Box>
                    <LogoMain />
                </Box>
                <Box sx={{ flexGrow: 1 }} />
                <Box>
                    <Box sx={{ height: "24px", width: "24px", marginRight: "10px", }}>
                        {i18n.language === "th-TH" ?
                            <Thai />
                            :
                            i18n.language === "en-US" ?
                                <En />
                                : null}
                    </Box>
                </Box>
                <Hidden lgDown>
                    {fullVersion &&
                        <IconButton color="white" onClick={() => navigate(`/kpi/inbox`, { replace: false })} disabled={!fullVersion}>
                            <Badge
                                badgeContent={showNotificationsBell?.total}
                                color="white"
                                max={10}
                                sx={{ ".MuiBadge-badge": { background: "#CC6058", border: "2px solid #404349", borderRadius: "3px", color: " #fff", fontWeight: "400", fontSize: "10px", lineHeight: "11px", width: "22px", height: "22px", } }}
                            >
                                <Bell id="bell" color="white" style={{ opacity: '50' }} />
                            </Badge>
                        </IconButton>
                    }
                    {proxy?.proxy_token === undefined ?
                        <Typography fontSize={16} fontWeight={400} lineHeight="21.86px" color="white" sx={{ padding: "0px 20px 0px 10px", color: "white !important" }}>
                            {selectNameUser(dataProfiles)}
                        </Typography>
                        :
                        <Box>
                            <Typography fontSize={16} fontWeight={300} lineHeight="21.86px" color="white" sx={{ padding: "0px 20px 0px 10px", color: "white !important", textAlign: "right" }}>
                                {selectNameUser(dataProfiles)}
                            </Typography>
                            <Typography fontSize={16} fontWeight={300} lineHeight="21.86px" color="white" sx={{ padding: "0px 20px 0px 10px", color: "white !important" }}>
                                {t('proxy.onBehalf')} <span style={{ fontSize: "16px", fontWeight: "400", lineHeight: "21.86px" }}>{selectName(proxy)}</span>
                            </Typography>
                        </Box>
                    }
                    <Avatar
                        src={proxy?.proxy_token === undefined ? imageProfile : proxy?.profile?.photo}
                        sx={{
                            width: 40,
                            height: 40,
                        }}
                    >
                    </Avatar>
                </Hidden>
                <Hidden lgUp>
                    {fullVersion &&
                        <IconButton color="white" onClick={() => navigate(`/kpi/inbox`, { replace: false })} disabled={!fullVersion}>
                            <Badge
                                badgeContent={showNotificationsBell?.total}
                                color="white"
                                max={10}
                                sx={{ ".MuiBadge-badge": { background: "#CC6058", border: "2px solid #404349", borderRadius: "3px", color: " #fff", fontWeight: "400", fontSize: "10px", lineHeight: "11px", width: "22px", height: "22px", } }}
                            >
                                <Bell id="bell" color="white" style={{ opacity: '50' }} />
                            </Badge>
                        </IconButton>
                    }
                    {proxy?.proxy_token === undefined ?
                        <Typography fontSize={16} fontWeight={400} lineHeight="21.86px" color="white" sx={{ padding: "0px 20px 0px 10px", color: "white !important" }}>
                            {selectNameUser(dataProfiles)}
                        </Typography>
                        :
                        <Box>
                            <Typography fontSize={16} fontWeight={300} lineHeight="21.86px" color="white" sx={{ padding: "0px 20px 0px 10px", color: "white !important", textAlign: "right" }}>
                                {selectNameUser(dataProfiles)}
                            </Typography>
                            <Typography fontSize={16} fontWeight={300} lineHeight="21.86px" color="white" sx={{ padding: "0px 20px 0px 10px", color: "white !important" }}>
                                {t('proxy.onBehalf')} <span style={{ fontSize: "16px", fontWeight: "400", lineHeight: "21.86px" }}>{selectName(proxy)}</span>
                            </Typography>
                        </Box>
                    }
                    <Avatar
                        src={proxy?.proxy_token === undefined ? imageProfile : proxy?.profile?.photo}
                        sx={{
                            width: 40,
                            height: 40,
                        }}
                    >
                    </Avatar>
                </Hidden>
                <Box ml="12px" sx={{ position: "relative" }} id="boxCollapse">
                    <Polygon style={{ cursor: "pointer" }} onClick={displayCollapse} />
                    <Box sx={{ position: "absolute", right: "0", top: "59px" }} >
                        <Collapse in={isCollapse}>
                            {proxy?.proxy_token === undefined ?
                                <Box pt="5px" sx={{ minWidth: "175px", background: "#FFFFFF", border: "1px solid #BABABA", "box-shadow": "0px 4px 4px rgba(0, 0, 0, 0.25)", "border-radius": "4px" }}>
                                    <Box>
                                        <Box px="15px" py="10px" display="flex" onClick={() => clickLink('/app/profile')} sx={{ position: "relative", "&:hover": { cursor: "pointer", "&:before": { content: '""', position: "absolute", top: "3px", left: "3px", height: "calc(100% - 6px)", width: "calc(100% - 6px)", background: "rgba(93, 161, 150, 0.2)", "border-radius": "4px", } } }}>
                                            <Box width="25px" alignItems="center" display="flex">
                                                <Profile />
                                            </Box>
                                            <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ width: "calc(100% - 25px)", color: "#404349", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                {t('proxy.myProfile')}
                                            </Typography>
                                        </Box>
                                        <Divider />
                                    </Box>
                                    {dataProfiles?.permission !== undefined && dataProfiles?.permission !== null ? dataProfiles?.permission.filter((item) => item.view === true && item.code === "proxy").length > 0 && dataProfiles?.permission.filter((item) => item.view === true && item.code === "proxy")[0]?.have_permission_group === true ?
                                        <Box>
                                            <Box px="15px" py="10px" display="flex" onClick={openSelect} sx={{ position: "relative", "&:hover": { cursor: "pointer", "&:before": { content: '""', position: "absolute", top: "3px", left: "3px", height: "calc(100% - 6px)", width: "calc(100% - 6px)", background: "rgba(93, 161, 150, 0.2)", "border-radius": "4px", } } }}>
                                                <Box width="25px" alignItems="center" display="flex">
                                                    <Proxy />
                                                </Box>
                                                <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ width: "calc(100% - 25px)", color: "#404349", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {t('proxy.proxy')}
                                                </Typography>
                                            </Box>
                                            <Divider />
                                        </Box>
                                        :
                                        null
                                        :
                                        null
                                    }


                                    {(dataProfiles?.permission !== undefined && dataProfiles?.permission !== null && dataProfiles?.permission.filter((item) => item.view === true && item.code === "proxy_history").length > 0) &&
                                        <Box>
                                            <Box px="15px" py="10px" display="flex" onClick={() => clickLink('/app/proxy-history')} sx={{ position: "relative", "&:hover": { cursor: "pointer", "&:before": { content: '""', position: "absolute", top: "3px", left: "3px", height: "calc(100% - 6px)", width: "calc(100% - 6px)", background: "rgba(93, 161, 150, 0.2)", "border-radius": "4px", } } }}>
                                                <Box width="25px" alignItems="center" display="flex">
                                                    <History />
                                                </Box>
                                                <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ width: "calc(100% - 25px)", color: "#404349", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {t('proxy.proxyHistory')}
                                                </Typography>
                                            </Box>
                                            <Divider />
                                        </Box>
                                    }

                                    <Box>
                                        <Box px="15px" py="10px" display="flex" onClick={logouts} sx={{ position: "relative", "&:hover": { cursor: "pointer", "&:before": { content: '""', position: "absolute", top: "3px", left: "3px", height: "calc(100% - 6px)", width: "calc(100% - 6px)", background: "rgba(93, 161, 150, 0.2)", "border-radius": "4px", } } }}>
                                            <Box width="25px" alignItems="center" display="flex">
                                                <Logout />
                                            </Box>
                                            <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ width: "calc(100% - 25px)", color: "#404349", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                {t('sidebar.label.logOut')}
                                            </Typography>
                                        </Box>
                                    </Box>

                                </Box>
                                : null
                            }
                            {proxy?.proxy_token !== undefined ?
                                <Box pt="5px" sx={{ minWidth: "175px", background: "#FFFFFF", border: "1px solid #BABABA", "box-shadow": "0px 4px 4px rgba(0, 0, 0, 0.25)", "border-radius": "4px" }}>
                                    <Box>
                                        <Box px="15px" py="10px" display="flex" onClick={proxyOut} sx={{ position: "relative", "&:hover": { cursor: "pointer", "&:before": { content: '""', position: "absolute", top: "3px", left: "3px", height: "calc(100% - 6px)", width: "calc(100% - 6px)", background: "rgba(93, 161, 150, 0.2)", "border-radius": "4px", } } }}>
                                            <Box width="25px" alignItems="center" display="flex">
                                                <Profile />
                                            </Box>
                                            <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ width: "calc(100% - 25px)", color: "#404349", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                {t('proxy.becomeSelf')}
                                            </Typography>
                                        </Box>
                                        <Divider />
                                    </Box>
                                    <Box>
                                        <Box px="15px" py="10px" display="flex" onClick={logouts} sx={{ position: "relative", "&:hover": { cursor: "pointer", "&:before": { content: '""', position: "absolute", top: "3px", left: "3px", height: "calc(100% - 6px)", width: "calc(100% - 6px)", background: "rgba(93, 161, 150, 0.2)", "border-radius": "4px", } } }}>
                                            <Box width="25px" alignItems="center" display="flex">
                                                <Logout />
                                            </Box>
                                            <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ width: "calc(100% - 25px)", color: "#404349", "white-space": "nowrap", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                {t('sidebar.label.logOut')}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                : null
                            }
                        </Collapse>
                    </Box>
                </Box>
            </Toolbar >
            <SelectUser open={openSelectUser} setOpen={closeSelect} submit={submit} />
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="xs"
                fullWidth={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }} pt={4}>
                        <DialogCheck></DialogCheck>
                        <Typography color="primary" variant="h3" mt={3}>{t("label.done")}</Typography>
                        <Typography textAlign="center" mt={2} dangerouslySetInnerHTML={{ __html: text }}>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
                    <Button onClick={handleClose} size="large" variant="contained" sx={{ width: '300px' }}>{t(`label.close`)}</Button>
                </DialogActions>
            </Dialog>
        </AppBar >
    );
};
DashboardNavbar.propTypes = {
    onMobileNavOpen: PropTypes.func
};
export default DashboardNavbar;
